export default __webpack_public_path__ + "static/media/top-videos-img-two.a2bb654f.png";